import { Typography } from "@mui/material";
import DocumentContext from "components/DocumentContext";
import PageWrapper from "components/PageWrapper";
import makeStyles from "@mui/styles/makeStyles";
import { theme } from "app/theme";

const useStyles = makeStyles({
    videoContainer: {
        position: "relative",
        overflow: "hidden",
        width: "100%",
        paddingTop: "56.25%", // 16:9 Aspect Ratio
        marginBottom: theme.spacing(4),
    },
    iframe: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: theme.borderRadius.default,
    },
});

export const DropInSessionsMonthlyThemePage = () => {
    const classes = useStyles();
    return (
        <div>
            <DocumentContext title="Monthly Theme" addBrandNameSuffix />

            <PageWrapper>
                <Typography variant="h1">
                    Monthly theme for January: Reflect &amp; Reset Yourself
                </Typography>

                <div className={classes.videoContainer}>
                    <iframe
                        src="https://www.youtube.com/embed/ct3gdnJzsY0?si=jD2zZGjVQXxpqKw8"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                        className={classes.iframe}
                    ></iframe>
                </div>

                <Typography variant="body1">
                    <ul>
                        <li>
                            Take an honest, compassionate look at your life. Be intentional about
                            choosing specific ways you’d like to grow this year and what old habits
                            you’re practicing letting go.
                        </li>
                        <li>Recall a moment this week where you felt at peace. What led to it?</li>
                        <li>What are three things you're grateful for right now?</li>
                        <li>
                            What recent experience taught you something unexpected about yourself?
                        </li>
                        <li>
                            Imagine your ideal day. What's one thing you can do to make it real?
                        </li>
                        <li>Reflect on your biggest challenge this year. What did it teach you?</li>
                        <li>If you could let go of one worry, what would it be?</li>
                        <li>If you could give advice to your past self, what would it be?</li>
                        <li>What's something new you'd like to try or learn next month?</li>
                        <li>Think of a habit you'd like to change. What's your first step?</li>
                        <li>
                            Think of someone who inspires you. What qualities do you admire in them?
                        </li>
                    </ul>
                </Typography>
            </PageWrapper>
        </div>
    );
};
